"use client";
import { jsx } from "react/jsx-runtime";
import { DropdownUserItem } from "../../primitive-dropdown/dropdown-user-item.js";
import { AsyncGenericDropdown } from "./async-generic-dropdown.js";
function AsyncUsersDropdown({ users, ...props }) {
    const options = users.map((option)=>({
            value: option.value,
            label: option.name,
            element: (elementProps)=>/*#__PURE__*/ jsx(DropdownUserItem, {
                    user: option,
                    ...elementProps
                })
        }));
    return /*#__PURE__*/ jsx(AsyncGenericDropdown, {
        ...props,
        options: options
    });
}
export { AsyncUsersDropdown };
